import { render, staticRenderFns } from "./PatentDemand.vue?vue&type=template&id=23da92b1&scoped=true&"
import script from "./PatentDemand.vue?vue&type=script&lang=js&"
export * from "./PatentDemand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23da92b1",
  null
  
)

export default component.exports